import { matchErrorString } from "./matchers"
import { getErrorDetails } from "./messages"
import type { ResolvedError } from "./types"

export function resolveError(rawError: string | Error | unknown): ResolvedError {
    let errorString: string

    if (rawError instanceof Error) {
        errorString = rawError.message
    } else if (typeof rawError === "string") {
        errorString = rawError
    } else {
        errorString = String(rawError)
    }

    const code = matchErrorString(errorString)
    return getErrorDetails(code)
}
